import React, { useRef, useState } from 'react';
import { uploadFiles } from '../api/dicomApi';

export default function UploadZone({ onUploaded }) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [summary, setSummary] = useState(null);

  const handleFiles = async (fileList) => {
    if (!fileList || fileList.length === 0) return;
    setUploading(true);
    setSummary(null);
    try {
      const { data } = await uploadFiles(fileList);
      setSummary(data);
      onUploaded?.();
    } catch (err) {
      setSummary({ error: err.response?.data?.error || err.message });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDragActive(true); }}
      onDragLeave={() => setDragActive(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragActive(false);
        handleFiles(e.dataTransfer.files);
      }}
      className={`rounded-sm border-2 border-dashed p-8 text-center transition-colors ${
        dragActive ? 'border-phosphor bg-phosphor/5' : 'border-line bg-panel'
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".dcm,application/dicom"
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <p className="text-text mb-1">Drag &amp; drop DICOM files here</p>
      <p className="text-textdim text-xs uppercase tracking-wider mb-4">or</p>
      <button
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="px-4 py-2 rounded-sm bg-phosphor hover:bg-phosphordim text-ink text-sm font-semibold transition-colors disabled:opacity-50"
      >
        {uploading ? 'Uploading…' : 'Browse files'}
      </button>

      {summary && (
        <div className="mt-4 text-sm text-left max-w-md mx-auto font-data">
          {summary.error && <p className="text-rose">{summary.error}</p>}
          {summary.results && (
            <ul className="space-y-1">
              {summary.results.map((r, i) => (
                <li key={i} className={r.status === 'ok' ? 'text-phosphor' : 'text-rose'}>
                  {r.filename} — {r.status === 'ok' ? 'uploaded' : r.error}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
